module.exports = "<svg id=\"585b3f9f-7b0e-42ae-91c7-b5886995b244\" data-name=\"Layer 1\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 50 50\"><title>RightCarot</title><path d=\"M14.58,5.73,28,22.5h-.1l2.34,2.86-2.3,2.85H28L14.58,45A3,3,0,0,0,15,49a2.87,2.87,0,0,0,4-.45l17.12-21.4a2.61,2.61,0,0,0,.62-1.78h0a4.21,4.21,0,0,0-.62-1.78L19,2.16a2.87,2.87,0,0,0-4-.45A3,3,0,0,0,14.58,5.73Z\"></path></svg>"


//////////////////
// WEBPACK FOOTER
// ./src/assets/icons/RightCarot.svg
// module id = 523
// module chunks = 1